/**
 * Shared header used at the top of every portal page.
 *
 * Renders an uppercase kicker, an H1 and an optional subtitle. All copy is
 * provided via i18n translation keys to keep FR/EN parity.
 */
import { useTranslation } from "react-i18next";

export const PortalPageHeader = ({ kickerKey, titleKey, subtitleKey, right, kickerArgs }) => {
  const { t } = useTranslation();
  return (
    <header className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
      <div>
        {kickerKey && (
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            {t(kickerKey, kickerArgs)}
          </p>
        )}
        <h1 className="mt-3 font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
          {t(titleKey)}
        </h1>
        {subtitleKey && (
          <p className="mt-3 text-sm md:text-base text-slate-600 max-w-xl">
            {t(subtitleKey)}
          </p>
        )}
      </div>
      {right}
    </header>
  );
};

export default PortalPageHeader;
